import './registerServiceWorker';
import './base.styl';

import Vue from 'vue';
import store from './store';
import router from './router';
import apolloProvider from './graphql';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import { Capacitor } from '@capacitor/core';
import firebaseConfig from './firebase-config';

import { App as CapApp } from '@capacitor/app';
import MFAPhoneAuth from './plugins/mfa-phone-auth';

// Initialize Firebase app if not already initialized
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

if (process.env.VUE_APP_PLATFORM === 'cordova') {
  var cordovaScript = document.createElement('script');
  cordovaScript.setAttribute('type', 'text/javascript');
  cordovaScript.setAttribute('src', 'cordova.js');
  document.body.appendChild(cordovaScript);
}

import GmapVue from 'gmap-vue';

Vue.use(GmapVue, {
  load: {
    // [REQUIRED] This is the unique required value by Google Maps API
    key: process.env.GMAPS_API_KEY || 'AIzaSyAlpArQPeJtpPIAoQxXOsZbYI3wBDXQsVs',
  },
});

// Adds media-query support for conditional rendering based on breakpoints
import VueMq from 'vue-mq';
Vue.use(VueMq, {
  breakpoints: {
    sm: 800,
    lg: 1250,
    xlg: Infinity,
  },
});

import CWKit from './components/cwkit';
Vue.use(CWKit);

import ModalPlugin from './components/plugins/modal';
Vue.use(ModalPlugin);

import './components/icons';
import IconComponent from 'vue-awesome/components/Icon';
Vue.component('icon', IconComponent);

import Broadcaster from './components/plugins/broadcaster';
Vue.use(Broadcaster);

// Entry Component
import App from './App';

Vue.config.productionTip = false;

// Initialize reCAPTCHA verifier once globally for MFA
window.recaptchaVerifier = null;

window.addEventListener('load', () => {
  window.app = new Vue({
    el: '#app',
    store,
    router,
    apolloProvider,
    data: {
      multipleLocations: false,
    },
    mounted() {
      // Initialize reCAPTCHA after Vue app and DOM are ready (web only)
      // Mobile uses native App Check attestation instead
      if (!Capacitor.isNativePlatform()) {
        window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
          'recaptcha-container',
          { size: 'invisible' }
        );
      }
    },
    async created() {
      // Restore the currently logged in user, if there is one.

      if (Capacitor.isNativePlatform()) {
        // Native: Check for persisted user in native Firebase SDK
        try {
          console.log('📱 Checking for persisted native user...');
          const result = await MFAPhoneAuth.getCurrentUser();
          console.log('📱 getCurrentUser result:', JSON.stringify(result));

          if (result.hasUser && result.idToken) {
            console.log('📱 Found persisted user:', result.email);
            await this.$store.dispatch('user/restoreSignInFromNative', {
              idToken: result.idToken,
              uid: result.uid,
              email: result.email,
              displayName: result.displayName,
              phoneNumber: result.phoneNumber,
              emailVerified: result.emailVerified || false,
              mfaEnabled: result.mfaEnabled || false,
            });

            let pendingRoute = this.$store.state.pendingRoute;
            if (pendingRoute && pendingRoute.length > 0) {
              router.push({ path: pendingRoute });
            }
          } else {
            console.log('📱 No persisted native user found');
            this.$store.commit('user/authenticated', { success: false });
          }
        } catch (error) {
          console.error('📱 Error checking persisted user:', error);
          this.$store.commit('user/authenticated', { success: false });
        }
      } else {
        // Web: Use Firebase JS SDK's onAuthStateChanged
        firebase.auth().onAuthStateChanged(user => {
          if (user) {
            this.$store.dispatch('user/restoreSignIn', { user }).then(() => {
              let pendingRoute = this.$store.state.pendingRoute;
              if (pendingRoute && pendingRoute.length > 0) {
                router.push({ path: pendingRoute });
              }
            });
          } else {
            this.$store.commit('user/authenticated', { success: false });
          }
        });
      }
    },
    render: h => h(App),
  });
});

CapApp.addListener('backButton', () => {
  window.history.back();
});
